import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export default function MaskedLines({
    lines,
    className = "",
    delay = 0,
    stagger = 0.12,
}) {
    return (
        <span className={className}>
            {lines.map((line, i) => (
                <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
                    <motion.span
                        className="block will-change-transform"
                        initial={{ y: "115%" }}
                        animate={{ y: 0 }}
                        transition={{
                            duration: 1,
                            ease: EASE,
                            delay: delay + i * stagger,
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}
